import { render, staticRenderFns } from "./TheAuthorisedMenu.vue?vue&type=template&id=21ca9828&"
import script from "./TheAuthorisedMenu.vue?vue&type=script&lang=ts&"
export * from "./TheAuthorisedMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports